import { Component } from '@angular/core';

import { QuoteInfoService } from '../../services/quote-info.service';
import { ApprovedLockService } from '../../services/approved-lock.service';
import { QuoteService } from '../../services/quote.service';
import { ApplicationStateService } from '../../services/application-state.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { OptionsService } from '../../services/options.service';
import { BrowserWidthService } from '../../services/browser-width.service';
import { PageTitleService } from '../../services/page-title.service';
import { QuoteRevisionService } from '../../services/quote-revision.service';

import { Constants } from '../../model/constants';
import { Quote } from '../../model/quote';
import { QuoteRevision } from '../../model/quote-revision';

@Component({
  selector: 'edit-quote-warning',
  template: require('./edit-quote-warning.component.html'),
  styles: [require('./edit-quote-warning.component.scss')]
})
export class EditQuoteWarningComponent {
  approvalStatus: string;
  quote: Quote;
  quoteId: number;

  constructor(
    private pageTitleService: PageTitleService,
    public quoteInfoService: QuoteInfoService,
    public approvedLockService: ApprovedLockService,
    public quoteService: QuoteService,
    public applicationStateService: ApplicationStateService,
    public spinner: LoadingSpinnerService,
    public optionsService: OptionsService,
    public browserWidthService: BrowserWidthService,
    public quoteRevisionService: QuoteRevisionService
  ) {
    this.quoteInfoService.quote$.subscribe(x => {
      if (x && x.ApprovalStatusDescription) {
        this.quoteId = x.quoteId;
        this.approvalStatus = x.ApprovalStatusDescription.toLowerCase();
      }
    });
  }

  updateQuote(revisionComments: string) {
    this.quoteService.getQuoteById(this.quoteId, true).subscribe(y => {
		this.quote = y;
		this.spinner.showSpinner();
		this.approvedLockService.hideModal();
		let quoteRevision = new QuoteRevision();
		quoteRevision.QuoteId = this.quote.quoteId;
		quoteRevision.RevisionNumber = 0;
		quoteRevision.RevisionComments =
			revisionComments === null ||
				revisionComments === undefined ||
				revisionComments === ''
				? 'New Revision ' + new Date().toJSON().slice(0, 10)
				: revisionComments;

		this.quoteService.updateQuoteCreateNewRevision(quoteRevision)
			.subscribe(x => {
				this.browserWidthService.modalActive$.next(false);
				if (x.ApprovalStatusDescription !== null && x.ApprovalStatusDescription !== undefined) {
					this.quote.ApprovalStatusDescription = x.ApprovalStatusDescription;
				}
				this.quote.approvalStatus = (x !== null && x !== undefined && x.approvalStatus !== null && x.approvalStatus !== undefined) ? x.approvalStatus : 0;
				this.quote.QuoteStatusesID = (x !== null && x !== undefined && x.QuoteStatusesID !== null && x.QuoteStatusesID !== undefined) ? x.QuoteStatusesID : 0;
				this.quote.revisionNumber = (x !== null && x !== undefined && x.revisionNumber !== null && x.revisionNumber !== undefined) ? x.revisionNumber : 0;
				this.quote.revisionComments = (x !== null && x !== undefined && x.revisionComments !== null && x.revisionComments !== undefined) ? x.revisionComments : '';
				this.applicationStateService.setQuote(x);
				this.quoteInfoService.quote$.next(this.quote);
				this.optionsService.enableSaveButton$.next(true);
				this.spinner.hideSpinner();
			});




		//this.quote.ApprovalStatusDescription = null;
		//this.quote.approvalStatus = 0;
		//this.quote.QuoteStatusesID = 0;
		//this.quote.revisionNumber += 1;
		//this.quoteService.updateQuoteCreateNewRevision(this.quote, revisionComments)
		//	.subscribe(x => {
		//		this.browserWidthService.modalActive$.next(false);
		//		if (x.ApprovalStatusDescription !== null && x.ApprovalStatusDescription !== undefined) {
		//		  this.quote.ApprovalStatusDescription = x.ApprovalStatusDescription;
		//		}
		//		x.revisionNumber = this.quote.revisionNumber;
		//		this.applicationStateService.setQuote(x);
		//		this.quoteInfoService.quote$.next(this.quote);
		//		this.optionsService.enableSaveButton$.next(true);
		//		this.spinner.hideSpinner();
		//		let quoteRevision = new QuoteRevision();
		//		quoteRevision.QuoteId = x.quoteId;
		//		quoteRevision.RevisionNumber = x.revisionNumber;
		//		quoteRevision.RevisionComments =
		//		  revisionComments === null ||
		//		  revisionComments === undefined ||
		//		  revisionComments === ''
		//			? 'New Revision ' + new Date().toJSON().slice(0, 10)
		//			: revisionComments;
		//		this.quoteRevisionService.insertQuoteRevision(quoteRevision);
		//	});

      this.pageTitleService.pageTitle.next({
        title: Constants.CmhConnectionTitle,
        subTitle: Constants.CurrentQuoteSubTitle + this.quote.quoteId
      });
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/edit-quote-warning/edit-quote-warning.component.ts